import { Button } from 'ui';

type P = {
  isCurrent: boolean;
  onNavigate: () => void;
  title: string;
};

const AssetsFilePathItem = ({ isCurrent, onNavigate, title }: P) => {
  if (isCurrent) {
    return title;
  }

  return (
    <Button onClick={onNavigate} size="small" type="link-secondary">
      <>{title}</>
    </Button>
  );
};

export default AssetsFilePathItem;
